
import {
  defineComponent,
  ref,
  computed,
  PropType,
} from 'vue';
import { _CreatedUser } from '../composables/index';
import { IUserForm } from '@/api/manage-app/user-info/index.d';

export default defineComponent({
  name: 'CreatedDevAccount',
  emits: ['update:visible', 'handleSearch'],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    accountUserItem: {
      type: Object as PropType<IUserForm>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const disabledVisible = computed({
      get() {
        return props.visible;
      },
      set(val: boolean) {
        emit('update:visible', val);
      },
    });
    const formData = ref({
      remark: '', // 备注
    });

    const {
      handleDisClose,
      handleDisSave,
    } = _CreatedUser(
      formData,
      emit as any,
    );

    return {
      formData,
      disabledVisible,
      rules: {
        remark: [
          { required: true, message: '请输入备注', trigger: 'blur' },
        ],
      },
      handleDisClose,
      handleDisSave,
    };
  },
});
